import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-53461238"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "wrapper" };
var _hoisted_2 = { class: "content" };
var _hoisted_3 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("p", { class: "tip" }, "审核未通过原因", -1); });
var _hoisted_4 = /*#__PURE__*/ _createTextVNode("确定审核不通过");
import { ref } from "vue";
import { Button, NavBar, Icon, Field, Toast } from "vant";
export default /*#__PURE__*/ _defineComponent({
    __name: 'auditReject',
    emits: ["ok", "cancel"],
    setup: function (__props, _a) {
        var emit = _a.emit;
        var reason = ref("");
        var handleReject = function () {
            if (!reason.value) {
                return Toast("请输入审核未通过原因！");
            }
            emit("ok", reason.value);
        };
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(NavBar), {
                    title: "审核未通过原因",
                    onClickLeft: _cache[0] || (_cache[0] = function ($event) { return (emit('cancel')); })
                }, {
                    left: _withCtx(function () { return [
                        _createVNode(_unref(Icon), {
                            color: "rgba(0,0,0,0.9)",
                            name: "arrow-left",
                            size: "24"
                        })
                    ]; }),
                    _: 1
                }),
                _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _createVNode(_unref(Field), {
                        modelValue: reason.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((reason).value = $event); }),
                        autosize: "",
                        type: "textarea",
                        maxlength: "50",
                        placeholder: "请输入审核未通过原因",
                        "show-word-limit": ""
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", {
                        style: _normalizeStyle({
                            position: 'fixed',
                            bottom: 0,
                            left: 0,
                            right: 0,
                            padding: '0.48rem',
                        })
                    }, [
                        _createVNode(_unref(Button), {
                            color: "#3DABA4",
                            block: "",
                            onClick: handleReject
                        }, {
                            default: _withCtx(function () { return [
                                _hoisted_4
                            ]; }),
                            _: 1
                        })
                    ], 4)
                ])
            ]));
        };
    }
});
